<script setup lang="ts">
  import { useSwipe, type UseSwipeDirection } from "@vueuse/core";

  interface Emits {
    (event: "onFlick:direction", direction: UseSwipeDirection): void;
  }
  const emit = defineEmits<Emits>();

  const onFlick = (direction: UseSwipeDirection) => {
    emit("onFlick:direction", direction);
  };

  const flickArea = ref(null);
  const flickThreshold = 0.3; // フリックと認識する速度の閾値
  let flickStartX = 0;
  let flickStartY = 0;
  let flickStartTime = 0;

  useSwipe(flickArea, {
    // スワイプ開始時の処理
    onSwipeStart: (event: TouchEvent) => {
      // スワイプ開始時の座標と時間を記録
      flickStartX = event.touches[0].pageX;
      flickStartY = event.touches[0].pageY;
      flickStartTime = event.timeStamp;
    },
    // スワイプ終了時の処理
    onSwipeEnd: (event: TouchEvent, direction: UseSwipeDirection) => {
      // スワイプ終了時の座標と時間を記録
      const flickEndX = event.changedTouches[0].pageX;
      const flickEndY = event.changedTouches[0].pageY;
      const flickEndTime = event.timeStamp;

      // スワイプ距離を計算
      const distanceX = flickEndX - flickStartX;
      const distanceY = flickEndY - flickStartY;
      const distance = Math.sqrt(distanceX ** 2 + distanceY ** 2);

      // スワイプ時間を計算
      const duration = flickEndTime - flickStartTime;

      // スワイプの速度を計算（スワイプ距離を時間で割る）
      const speed = distance / duration;

      // スワイプ速度が閾値を超えていたらフリックと判定
      if (speed > flickThreshold) {
        onFlick(direction);
      }
    },
    // オプションでイベントの感度を調整
    threshold: 10, // 最小移動距離
  });
</script>

<template>
  <div ref="flickArea">
    <slot></slot>
  </div>
</template>
